export default "__VITE_ASSET__5f2fdf70__"